var map = {
	"./kg": [
		410,
		3
	],
	"./kg.js": [
		410,
		3
	],
	"./ru": [
		411,
		4
	],
	"./ru.js": [
		411,
		4
	],
	"./translation.service": [
		408,
		5
	],
	"./translation.service.js": [
		408,
		5
	],
	"./translation.types": [
		407,
		6
	],
	"./translation.types.js": [
		407,
		6
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 507;
module.exports = webpackAsyncContext;